import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystahideforcorporateeventsinpune() {



  const cardData =
  {
    keyword: ' Innova Crysta Hire for Corporate Events in Pune',
    heading: 'Pune Corporate Cars India Private Limited: Innova Crysta Hire for Corporate Events in Pune',
    headingDescription: 'Pune Corporate Cars India Private Limited offers premium Innova Crysta hire for corporate events in Pune, providing spacious, comfortable, and stylish transportation for business meetings, conferences, product launches, client visits, and official gatherings. Our well-maintained Innova Crysta vehicles come with professional chauffeurs, ensuring punctual, safe, and hassle-free travel for executives and VIP guests. With plush interiors, superior ride quality, and flexible rental plans, Pune Corporate Cars India Private Limited delivers a reliable travel solution that enhances the corporate image and ensures a seamless transport experience for events across Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Innova Rental Pune Corporate",
    "description": "Innova Rental Pune Corporate offers comfortable and spacious Toyota Innova vehicles tailored for corporate mobility needs. Ideal for executive travel, team movements, and daily office commuting, this service provides professionally driven Innovas with reliable and timely operations."
  },
  {
    "name": "Innova Crysta Business Travel",
    "description": "Innova Crysta Business Travel delivers premium travel experiences for executives and business teams. With luxurious seating, smooth rides, and professional chauffeurs, the service ensures high-comfort transportation for meetings, events, and corporate visits."
  },
  {
    "name": "Corporate Innova Shuttle Pune",
    "description": "Corporate Innova Shuttle Pune provides dedicated shuttle services using Innovas for employee commute, multi-shift operations, and corporate routes. The service ensures safe, efficient, and well-managed transportation for teams across Pune."
  },
  {
    "name": "Premium Innova Hire Pune",
    "description": "Premium Innova Hire Pune offers high-end Innova and Innova Crysta vehicles for executives requiring superior comfort. Ideal for VIP travel, business tours, and corporate engagements, the service ensures luxury mobility with trained chauffeurs."
  },
  {
    "name": "Innova Crysta for Meetings Pune",
    "description": "Innova Crysta for Meetings Pune provides well-maintained Crysta vehicles for seamless travel to corporate meetings, presentations, and client visits. The service ensures punctual, comfortable, and professionally managed business travel."
  },
  {
    "name": "Innova Employee Pickup Drop Pune",
    "description": "Innova Employee Pickup Drop Pune offers structured commute solutions using Innovas for staff transportation. With GPS-enabled vehicles and experienced drivers, the service ensures safe and timely daily travel for employees."
  },
  {
    "name": "Innova Airport Corporate Cab Pune",
    "description": "Innova Airport Corporate Cab Pune delivers smooth and punctual airport transfers for executives and teams. Spacious Innovas with professional chauffeurs ensure hassle-free travel for flight arrivals, departures, and business schedules."
  },
  {
    "name": "Innova Outstation Hire Pune",
    "description": "Innova Outstation Hire Pune provides reliable and comfortable Innova and Crysta rentals for outstation corporate trips. Perfect for business travel to neighboring cities, the service ensures safe long-distance travel with skilled drivers."
  },
  {
    "name": "Innova Fleet Pune Corporate",
    "description": "Innova Fleet Pune Corporate offers dedicated Innova fleets for companies needing long-term mobility support. Ideal for executive travel, team movements, and client transportation, this service ensures consistent and dependable fleet availability."
  },
  {
    "name": "Innova Chauffeur Service Pune",
    "description": "Innova Chauffeur Service Pune provides professionally driven Innova and Crysta vehicles for corporate travel. Chauffeurs are trained, uniformed, and experienced, ensuring safe, comfortable, and premium-quality travel experiences."
  },
  {
    "name": "Innova Crysta Rental for Conferences Pune",
    "description": "Innova Crysta Rental for Conferences Pune offers high-capacity, comfortable vehicles for transporting delegates, speakers, and teams to corporate conferences and business events. The service ensures timely group mobility with premium comfort."
  },
  {
    "name": "Best Innova Hire Pune",
    "description": "Best Innova Hire Pune provides top-quality Innova and Crysta rentals featuring well-maintained vehicles, trained chauffeurs, and reliable travel management. Ideal for executives, meetings, and corporate outings."
  },
  {
    "name": "Affordable Innova Corporate Rental",
    "description": "Affordable Innova Corporate Rental offers budget-friendly Innova rental packages for companies requiring daily commute support, business travel, and intercity trips without compromising comfort and reliability."
  },
  {
    "name": "Innova Crysta Event Transport Pune",
    "description": "Innova Crysta Event Transport Pune delivers structured transportation for corporate events, exhibitions, seminars, and company gatherings. Premium Crysta vehicles ensure smooth and coordinated event mobility."
  },
  {
    "name": "Innova Crysta Office Travel Pune",
    "description": "Innova Crysta Office Travel Pune provides daily office commute services for executives and teams using comfortable Crysta vehicles. With optimized routing and trained drivers, the service ensures safe and punctual office travel."
  }
],

"tableData": [
  ["Innova Rental Pune Corporate", "Innova Crysta Business Travel"],
  ["Corporate Innova Shuttle Pune", "Premium Innova Hire Pune"],
  ["Innova Crysta for Meetings Pune", "Innova Employee Pickup Drop Pune"],
  ["Innova Airport Corporate Cab Pune", "Innova Outstation Hire Pune"],
  ["Innova Fleet Pune Corporate", "Innova Chauffeur Service Pune"],
  ["Innova Crysta Rental for Conferences Pune", "Best Innova Hire Pune"],
  ["Affordable Innova Corporate Rental", "Innova Crysta Event Transport Pune"],
  ["Innova Crysta Office Travel Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Hire for Corporate Events in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers premium Innova Crysta rental services for corporate events, ensuring comfort, class, and reliability for business travel needs."
  },
  {
    "WhyChooseheading": "Spacious & Luxurious Innova Crysta Fleet",
    "WhyChoosedescription": "Our well-maintained Innova Crysta vehicles provide ample legroom, superior comfort, and a premium experience ideal for VIP guests and corporate delegations."
  },
  {
    "WhyChooseheading": "Perfect for Corporate Conferences & Business Meetings",
    "WhyChoosedescription": "Whether it's a business meeting, conference, seminar, or offsite, we provide seamless Innova Crysta travel arrangements tailored for corporate requirements."
  },
  {
    "WhyChooseheading": "Professional Chauffeur Service",
    "WhyChoosedescription": "All Innova Crysta rentals include trained, uniformed, and experienced chauffeurs ensuring safe, professional, and timely transportation for executives."
  },
  {
    "WhyChooseheading": "On-Time & Hassle-Free Travel Management",
    "WhyChoosedescription": "Our punctual pickup and drop services ensure smooth coordination for corporate events, minimizing delays and ensuring your event runs perfectly."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Whether you need a Crysta for a few hours, a full day, or multiple days, we offer flexible rental packages suited for corporate gatherings."
  },
  {
    "WhyChooseheading": "Comfort & Safety Priority",
    "WhyChoosedescription": "Our Innova Crystas are regularly sanitized, serviced, and equipped with modern safety features—making them ideal for hassle-free corporate travel."
  },
  {
    "WhyChooseheading": "Dedicated Event Transportation Support",
    "WhyChoosedescription": "We provide round-the-clock coordination and support to manage transportation for large-scale corporate events, delegations, and VIP movements."
  }
]


























  }

const faqData = [
  {
    question: 'Do you provide Innova Crysta hire for corporate events in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers premium Innova Crysta rentals for corporate events, business conferences, and VIP executive travel in Pune.',
  },
  {
    question: 'Why is Innova Crysta suitable for corporate events?',
    answer: 'Innova Crysta provides luxury comfort, spacious seating, excellent legroom, and a smooth ride—ideal for executive and team travel.',
  },
  {
    question: 'How can companies book Innova Crysta for corporate events?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Do you offer multiple Innova Crysta vehicles for large corporate events?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides bulk booking and fleet support for large-scale corporate events and conferences.',
  },
  {
    question: 'Are chauffeurs included with Innova Crysta rentals?',
    answer: 'Absolutely. All bookings come with trained, professional, and uniformed chauffeurs.',
  },
  {
    question: 'Do you offer hourly or full-day packages for Innova Crysta?',
    answer: 'Yes, we provide hourly, half-day, full-day, and event-based rental packages for corporate clients.',
  },
  {
    question: 'Can Innova Crysta be booked for VIP corporate guests?',
    answer: 'Yes, Innova Crysta is a top choice for VIP executives due to its luxury and comfort.',
  },
  {
    question: 'What safety measures are followed for Innova Crysta corporate rentals?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by experienced chauffeurs following strict safety protocols.',
  },
  {
    question: 'What payment modes are available for Innova Crysta corporate bookings?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and offer corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Varun Shirole',
    feedback: 'We hired Innova Crysta cars for our corporate seminar. The service was punctual, professional, and extremely comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Tanvi Kamat',
    feedback: 'Perfect Innova Crysta service for our VIP guests. Pune Corporate Cars India Private Limited provided seamless arrangements and excellent chauffeurs.',
    rating: 5,
  },
];


















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Hire for Corporate Events in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/innova-crysta-corporate-pune.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers Innova Crysta hire for corporate events in Pune, providing premium business travel, employee pick-up and drop, airport transfers, outstation trips, and corporate conferences. Reliable chauffeur-driven Innova fleet for comfortable and timely corporate transport.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  
    "ratingCount": "4800", 
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500", 
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/innova-crysta-hire-corporate-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Innova Crysta Hire for Corporate Events in Pune | Premium Corporate Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers Innova Crysta hire for corporate events in Pune, providing premium business travel, employee pick-up and drop, airport transfers, outstation trips, and corporate conferences. Reliable chauffeur-driven Innova fleet for comfortable and timely corporate transport."
  />

  <meta
    name="keywords"
    content="Innova Rental Pune Corporate, Innova Crysta Business Travel, Corporate Innova Shuttle Pune, Premium Innova Hire Pune, Innova Crysta for Meetings Pune, Innova Employee Pickup Drop Pune, Innova Airport Corporate Cab Pune, Innova Outstation Hire Pune, Innova Fleet Pune Corporate, Innova Chauffeur Service Pune, Innova Crysta Rental for Conferences Pune, Best Innova Hire Pune, Affordable Innova Corporate Rental, Innova Crysta Event Transport Pune, Innova Crysta Office Travel Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystahideforcorporateeventsinpune;